/**
 * LifeRamp
 *
 * @author      Chetanya Gupta
 * @copyright   LifeRamp Inc.
 *
 * Built by Eonyx Infotech LLP.
 * @link https://eonyx.io
 *
 */

import React from "react";
import { View, StyleSheet, TouchableOpacity, FlatList, Linking } from "react-native";
import { EvilIcons } from '@expo/vector-icons';
import { Colors } from "../../themes/colors";
import MainText from "../../components/text/MainText";
import { SpacingH, FontSize } from "../../themes/sizes";
import { GlobalStyles } from "../../themes/styles";
import ContainerView from "../../components/main/ContainerView";
import MainMediumText from "../../components/text/MainMediumText";
import HeroSemiText from "../../components/text/HeroSemiText";

const OPEN_SOURCE_SOFTWARE = [
    {
        name: "@afaanbilal/random-string",
        copyright: "Copyright (c) 2021 Afaan Bilal",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/AfaanBilal/random-string/master/LICENSE"
    },
    {
        name: "@react-native-community/datetimepicker",
        copyright: "Copyright (c) 2019 React Native Community",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-native-datetimepicker/datetimepicker/master/LICENSE.md"
    },
    {
        name: "@react-native-community/masked-view",
        copyright: "Copyright (c) 2015-present, Facebook, Inc.",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-native-masked-view/masked-view/master/LICENSE"
    },
    {
        name: "@react-native-community/slider",
        copyright: "Copyright (c) 2019 react-native-community",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/callstack/react-native-slider/master/LICENSE.md"
    },
    {
        name: "@react-navigation/bottom-tabs",
        copyright: "Copyright (c) 2017 React Navigation Contributors",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-navigation/react-navigation/main/packages/bottom-tabs/LICENSE"
    },
    {
        name: " @react-navigation/drawer",
        copyright: "Copyright (c) 2017 React Navigation Contributors",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-navigation/react-navigation/main/packages/drawer/LICENSE"
    },
    {
        name: "@react-navigation/material-top-tabs",
        copyright: "Copyright (c) 2017 React Navigation Contributors",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-navigation/react-navigation/main/packages/material-top-tabs/LICENSE"
    },
    {
        name: "@react-navigation/native",
        copyright: "Copyright (c) 2017 React Navigation Contributors",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-navigation/react-navigation/main/packages/native/LICENSE"
    },
    {
        name: "@react-navigation/stack",
        copyright: "Copyright (c) 2017 React Navigation Contributors",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-navigation/react-navigation/main/packages/stack/LICENSE"
    },
    {
        name: "@reduxjs/toolkit",
        copyright: "Copyright (c) 2018 Mark Erikson",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/reduxjs/redux-toolkit/master/LICENSE"
    },
    {
        name: "axios",
        copyright: "Copyright (c) 2014-present Matt Zabriskie",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/axios/axios/master/LICENSE"
    },
    {
        name: "date-and-time",
        copyright: "Copyright (c) 2015 KNOWLEDGECODE",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/knowledgecode/date-and-time/master/LICENSE"
    },
    {
        name: "expo",
        copyright: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/expo/expo/master/LICENSE"
    },
    {
        name: "expo-app-loading",
        copyright: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/expo/expo/master/LICENSE"
    },
    {
        name: "expo-font",
        copyright: "https://raw.githubusercontent.com/expo/expo/master/LICENSE",
        license: "MIT License",
        link: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)"
    },
    {
        name: "expo-document-picker",
        copyright: "https://raw.githubusercontent.com/expo/expo/master/LICENSE",
        license: "MIT License",
        link: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)"
    },
    {
        name: "expo-image-picker",
        copyright: "https://raw.githubusercontent.com/expo/expo/master/LICENSE",
        license: "MIT License",
        link: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)"
    },
    {
        name: "expo-linear-gradient",
        copyright: "https://raw.githubusercontent.com/expo/expo/master/LICENSE",
        license: "MIT License",
        link: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)"
    },
    {
        name: "expo-localization",
        copyright: "https://raw.githubusercontent.com/expo/expo/master/LICENSE",
        license: "MIT License",
        link: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)"
    },
    {
        name: "expo-notifications",
        copyright: "https://raw.githubusercontent.com/expo/expo/master/LICENSE",
        license: "MIT License",
        link: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)"
    },
    {
        name: "expo-status-bar",
        copyright: "https://raw.githubusercontent.com/expo/expo/master/LICENSE",
        license: "MIT License",
        link: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)"
    },
    {
        name: "expo-web-browser",
        copyright: "https://raw.githubusercontent.com/expo/expo/master/LICENSE",
        license: "MIT License",
        link: "Copyright (c) 2015-present 650 Industries, Inc. (aka Expo)"
    },
    {
        name: "firebase",
        copyright: "Copyright (c) Google LLC.",
        license: "Apache-2.0",
        link: "https://raw.githubusercontent.com/firebase/firebase-js-sdk/master/LICENSE"
    },
    {
        name: "form-data",
        copyright: "Copyright (c) 2012 Felix Geisendörfer (felix@debuggable.com) and contributors",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/form-data/form-data/master/License"
    },
    {
        name: "mime",
        copyright: "Copyright (c) 2010 Benjamin Thomas, Robert Kieffer",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/broofa/mime/master/LICENSE"
    },
    {
        name: "react",
        copyright: "Copyright (c) Facebook, Inc. and its affiliates.",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/facebook/react/main/LICENSE"
    },
    {
        name: "react-dom",
        copyright: "Copyright (c) Facebook, Inc. and its affiliates.",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/facebook/react/main/LICENSE"
    },
    {
        name: "react-native",
        copyright: "Copyright (c) Facebook, Inc. and its affiliates.",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/facebook/react/main/LICENSE"
    },
    {
        name: "react-native-bouncy-checkbox",
        copyright: "Copyright (c) 2019 FreakyCoder",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/WrathChaos/react-native-bouncy-checkbox/master/LICENSE"
    },
    {
        name: "react-native-double-tap",
        copyright: "Copyright (c) 2018 Waseef Shawkat",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/awshawka/react-native-double-tap/master/LICENSE"
    },
    {
        name: "react-native-gesture-handler",
        copyright: "Copyright (c) 2016 Krzysztof Magiera",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/software-mansion/react-native-gesture-handler/master/LICENSE"
    },
    {
        name: "react-native-loading-spinner-overlay",
        copyright: "Copyright (c) 2016- Nick Baugh",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/joinspontaneous/react-native-loading-spinner-overlay/master/LICENSE"
    },
    {
        name: "react-native-modal",
        copyright: "Copyright (c) 2017 React Native Community",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-native-modal/react-native-modal/master/LICENSE.md"
    },
    {
        name: "react-native-multitap",
        copyright: "Copyright  © 2021 Eonyx Infotech LLP",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/eonyxio/react-native-multitap/master/LICENSE"
    },
    {
        name: "react-native-radio-buttons-group",
        copyright: "Copyright (c) 2021 Thakur Ballary",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/ThakurBallary/react-native-radio-buttons-group/main/LICENSE"
    },
    {
        name: "react-native-ratings",
        copyright: "Copyright (c) 2016 Monte Thakkar",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/Monte9/react-native-ratings/master/LICENSE"
    },
    {
        name: "react-native-reanimated",
        copyright: "Copyright (c) 2016 Krzysztof Magiera",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/software-mansion/react-native-reanimated/master/LICENSE"
    },
    {
        name: "react-native-responsive-screen",
        copyright: "Copyright (c) 2018 Tasos Maroudas",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/marudy/react-native-responsive-screen/master/LICENSE"
    },
    {
        name: "react-native-safe-area-context",
        copyright: "Copyright (c) 2019 Th3rd Wave",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/th3rdwave/react-native-safe-area-context/master/LICENSE"
    },
    {
        name: "react-native-screens",
        copyright: "Copyright (c) 2018 Krzysztof Magiera",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/software-mansion/react-native-screens/master/LICENSE"
    },
    {
        name: "@react-native-snap-carousal",
        copyright: "Copyright (c) 2021, Meliorence",
        license: "BSD 3-Clause License",
        link: "https://raw.githubusercontent.com/meliorence/react-native-snap-carousel/master/LICENSE"
    },
    {
        name: "@react-native-svg",
        copyright: "Copyright (c) [2015-2016] [Horcrux]",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-native-svg/react-native-svg/develop/LICENSE"
    },
    {
        name: "@react-native-tab-view",
        copyright: "Copyright (c) 2017 React Native Community",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/satya164/react-native-tab-view/main/LICENSE.md"
    },
    {
        name: "@react-native-vector-icons",
        copyright: "Copyright (c) 2015 Joel Arvidsson",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/oblador/react-native-vector-icons/master/LICENSE"
    },
    {
        name: "@react-native-web",
        copyright: "Copyright (c) 2015-present, Nicolas Gallagher.",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/necolas/react-native-web/master/LICENSE"
    },
    {
        name: "@react-native-webview",
        copyright: "Copyright (c) 2015-present, Facebook, Inc.",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/react-native-webview/react-native-webview/master/LICENSE"
    },
    {
        name: "@react-redux",
        copyright: "Copyright (c) 2015-present Dan Abramov",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/reduxjs/react-redux/master/LICENSE.md"
    },
    {
        name: "@react-time-ago",
        copyright: "Copyright (c) 2016 @catamphetamine",
        license: "MIT License",
        link: "https://gitlab.com/catamphetamine/react-time-ago/-/raw/master/LICENSE"
    },
    {
        name: "@tslib",
        copyright: "Copyright (c) Microsoft Corporation.",
        license: "BSD Zero Clause License",
        link: "https://raw.githubusercontent.com/microsoft/tslib/main/LICENSE.txt"
    },
    {
        name: "@rn-placeholder",
        copyright: "Copyright (c) 2004-Today Marvin Frachet",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/mfrachet/rn-placeholder/master/LICENSE.md"
    },
    {
        name: "babel/core",
        copyright: "Copyright (c) 2014-present Sebastian McKenzie and other contributors",
        license: "MIT License",
        link: "https://raw.githubusercontent.com/babel/babel/main/LICENSE"
    },
];

export default ({ navigation }) => (
    <ContainerView hasHeader>
        <View style={GlobalStyles.containerPaddingH}>
            <TouchableOpacity onPress={() => { navigation.goBack(); }} style={{ position: "absolute", top: 17, left: 10, zIndex: 10 }}>
                <EvilIcons name="chevron-left" size={42} color={Colors.BLUE_GREY} />
            </TouchableOpacity>
            <View style={{ marginVertical: SpacingH.s2 }}>
                <HeroSemiText style={{ fontSize: FontSize.MEDIUM, textAlign: "center" }}>Open Source Software</HeroSemiText>
            </View>
        </View>
        <View style={styles.paragraphContainer}>
            <MainText style={{ textAlign: "justify" }}>The following sets forth attribution notices for third-party software that may be contained in portions of this product.</MainText>
        </View>
        <FlatList
            keyExtractor={(item, index) => index.toString()}
            data={OPEN_SOURCE_SOFTWARE}
            renderItem={(itemData) => (
                <TouchableOpacity style={styles.copyrightItem} onPress={() => navigation.navigate("WebView", { url: itemData.item.link })}>
                    <View style={{ flexDirection: "row", marginBottom: SpacingH.s0 }}>
                        <MainMediumText style={{ flex: 3, fontSize: FontSize.SMALL }}>{itemData.item.name}</MainMediumText>
                        <MainText style={{ flex: 2, textAlign: "right", flexShrink: 1 }}>{itemData.item.license}</MainText>
                    </View>
                    <MainText>Copyright {'\u00A9'} {itemData.item.copyright}</MainText>
                </TouchableOpacity>
            )}
        />
    </ContainerView>
);

const styles = StyleSheet.create({
    paragraphContainer: {
        alignItems: "center",
        paddingBottom: SpacingH.s2,
        borderBottomWidth: 1,
        borderBottomColor: Colors.SOFT_GREY,
        paddingHorizontal: SpacingH.s3
    },
    copyrightItem: {
        paddingVertical: SpacingH.s2,
        borderBottomWidth: 1,
        borderBottomColor: Colors.SOFT_GREY,
        paddingHorizontal: SpacingH.s3
    }
});
